module.exports = __webpack_public_path__ + "wave-drawer-ee1bfcbe5811ea31771b7187c7507ee6.png";